"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SharedWidgets_1 = require("./SharedWidgets");
/**
 * Maintains media query lists that modify TabStyles and rerenders the widgets.
 */
var StyleMediaQueryManager = /** @class */ (function () {
    function StyleMediaQueryManager() {
    }
    StyleMediaQueryManager.setMediaStyleQueries = function (styleMediaQueries) {
        StyleMediaQueryManager.mediaQueryLists = {};
        for (var i = 0; i < styleMediaQueries.length; i++) {
            var styleMediaQuery = styleMediaQueries[i];
            var mediaQueryList = StyleMediaQueryManager.registerMediaQuery(styleMediaQuery);
            var mediaQueryListListener = StyleMediaQueryManager.getMediaQueryListListener(styleMediaQuery);
            mediaQueryListListener(mediaQueryList);
            // tslint:disable-next-line:deprecation
            mediaQueryList.addListener(mediaQueryListListener);
        }
    };
    StyleMediaQueryManager.registerMediaQuery = function (styleMediaQuery) {
        var mediaQuery = styleMediaQuery.mediaQuery;
        if (!(mediaQuery in StyleMediaQueryManager.mediaQueryLists)) {
            StyleMediaQueryManager.mediaQueryLists[mediaQuery] = window.matchMedia(mediaQuery);
        }
        return StyleMediaQueryManager.mediaQueryLists[mediaQuery];
    };
    // The standard library definitions have moved to the "new" spec for this, which is not supported by IE11,
    // so we'll keep on using the old one.
    // tslint:disable-next-line:no-any
    StyleMediaQueryManager.getMediaQueryListListener = function (styleMediaQuery) {
        return function (mediaQueryList) {
            if (mediaQueryList.matches) {
                SharedWidgets_1.setConfig({ styles: styleMediaQuery.matchingStyle });
            }
            else {
                SharedWidgets_1.setConfig({ styles: styleMediaQuery.nonMatchingStyle });
            }
        };
    };
    return StyleMediaQueryManager;
}());
exports.StyleMediaQueryManager = StyleMediaQueryManager;
//# sourceMappingURL=StyleMediaQueries.js.map